'use strict';

export default {
  navbar: {
    home: {
      title: 'Accueil',
    },
    dashboard: {
      title: 'Tableau de bord',
    },
    forms: {
      title: 'Formulaires',
    },
    settings: {
      title: 'Paramètres',
      paymentOptions: {
        title: 'Paiement',
        name: 'Paiement',
      },
      users: {
        title: 'Usagers',
        name: 'Usagers',
      },
      reports: {
        title: 'Rapports',
      },
      organization: {
        title: 'Organisation',
        name: 'Organisation',
      },
      notifications: {
        title: 'Notifications',
        name: 'Notifications',
      },
    },
    emptySubMenus: 'Aucun sous-menu accessible',
  },
};
